import { SizeProp } from '@fortawesome/fontawesome-svg-core';
import { faSquareInfo } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { HTMLAttributes } from 'react';

export interface InfoIconProps extends HTMLAttributes<SVGSVGElement> {
  size?: SizeProp;
  className?: string;
}

const InfoIcon = React.forwardRef<SVGSVGElement, InfoIconProps>(
  ({ size = null, className, ...otherProps }, ref) => {
    return (
      <FontAwesomeIcon
        ref={ref}
        icon={faSquareInfo}
        size={size}
        className={`cursor-help text-voxel-gray-400 ${className}`}
        {...otherProps}
      />
    );
  }
);

export default InfoIcon;
